
import Vue from 'vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import ILocation from '../interfaces/ilocation';

declare const Alkami: any;

export default Vue.extend({
  name: 'location-search',
  data() {
    return {
      Alkami,
      AnyLocations: false,
      IsSearchHistoryVisible: false
    };
  },
  computed: {
    ...mapGetters(
        [
            'getSearchText',
            'getShowFilterButton',
            'getSearchHistory',
            'getAllLocations',
            'getShowMyLocation',
            'getIsSearching',
            'getHasSearched'
        ]
    ),
    ...mapState(['Locations'])
  },
  watch: {
    getAllLocations(value: ILocation[]) {
      this.AnyLocations = value.length > 0;
    },
  },
  methods: {
    ...mapMutations(['setIsRecentHistorySearch','setSearchText','setSearchHistoryIndex']),
    ...mapActions(['getMapCurrentPositionAsync','initGMapComponentsAsync']),
      showSearchHistory() {
          this.IsSearchHistoryVisible = this.getSearchHistory && this.getSearchHistory.length !== 0;
      },
      hideSearchHistory(e: any) {
          if (!e.relatedTarget) {
              this.IsSearchHistoryVisible = false;
          }
      },
    clickUseMyLocation() {
      this.getMapCurrentPositionAsync();
    },
    async clickRecentSearch(index: string | number,entry: string) {
      this.setSearchText(entry);
      this.setSearchHistoryIndex(index);
      this.setIsRecentHistorySearch(true);    
      this.IsSearchHistoryVisible = false;
      await this.initGMapComponentsAsync('desktop');
    }
  }
});
